const General = ({ applicant }) => {
    return (
        <>
            <div className='RegisteredApplicant__Info'>
                <p className='RegisteredApplicant__Info__Text--Highlight'>PROCESO PARA EL PAGO DE EXAMEN DE ADMISIÓN:</p>
                <ol className='RegisteredApplicant__Info__OrderedList'>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Acude a <span className='RegisteredApplicant__Info__Text--Highlight'>{applicant.nameNormalSchool}</span> del estado de <span className='RegisteredApplicant__Info__Text--Highlight'>{applicant.nameNormalState}</span>.</li>
                    <ol className='RegisteredApplicant__Info__OrderedList__Sublist'>
                        <li className='RegisteredApplicant__Info__OrderedList__Items'>Realiza el pago de tu examen de admisión en el área correspondiente</li>
                        <li className='RegisteredApplicant__Info__OrderedList__Items'>Debes recibir un comprobante de pago. <span className='RegisteredApplicant__Info__Text--Highlight'>Guárdalo</span>.</li>
                    </ol>
                    
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Dirígete con el administrador de Riactivos en <span className='RegisteredApplicant__Info__Text--Highlight'>{applicant.nameNormalSchool}</span> del estado de <span className='RegisteredApplicant__Info__Text--Highlight'>{applicant.nameNormalState}</span> y proporciónale:</li>
                    <ol className='RegisteredApplicant__Info__OrderedList__Sublist'>
                        <li className='RegisteredApplicant__Info__OrderedList__Items'>Comprobante de pago.</li>
                        <li className='RegisteredApplicant__Info__OrderedList__Items'>Ficha del examen de admisión (este documento).</li>
                        <li className='RegisteredApplicant__Info__OrderedList__Items'>Él autorizará tu acceso y confirmará el código.</li>
                    </ol>

                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Conserva tu comprobante de pago, la ficha y el código de acceso.</li>
                </ol>
            </div>

            <div className='RegisteredApplicant__Info'>
                <p className='RegisteredApplicant__Info__Text--Highlight'>PROCESO PARA APLICAR EL EXAMEN DE ADMISIÓN:</p>
                <ol className='RegisteredApplicant__Info__OrderedList'>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Ingresa a <a href='https://riactivos.com' className='RegisteredApplicant__Info__Text--Link'>https://riactivos.com</a></li>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Escribe tu código de acceso.</li>
                    <li className='RegisteredApplicant__Info__OrderedList__Items'>Valida tus datos y aplica los exámenes correspondientes.</li>
                </ol>
            </div>

            <div className='RegisteredApplicant__Info'>
                <p className='RegisteredApplicant__Info__Text--Highlight'>INFORMACIÓN ADICIONAL:</p>
                <ul className='RegisteredApplicant__Info__UnorderedList'>
                    <li className='RegisteredApplicant__Info__UnorderedList__Items'>Consulta con la escuela normal la fecha y lugar de aplicación del examen.</li>
                </ul>
            </div>
        </>
    )
}

export { General };